export const recalcServiceWithProductQuantities = (services, quantities) => {
  if (!services) return [];
  return services.map(service => { 
    // Apply debounced quantities to service_options and calculate new totals
    const updatedServiceOptions = service.service_options.map(serviceOption => {
      const productId = serviceOption.product_id || serviceOption.product._id;
      const quantity = quantities[productId] || 0;
      const unitPrice = serviceOption.service_rate?.price_cents || serviceOption.price_cents || 0;
    
      // remove pennies from unit price to match pricing api
      return {
        ...serviceOption,
        quantity: quantity,
        price_cents: unitPrice,
        total_price_cents: unitPrice * quantity,
        adjusted_price_cents: 0,
        total_adjusted_price_cents: 0
      };
    });

    // Calculate overall service totals by summing all service options
    const totalServicePriceCents = updatedServiceOptions.reduce((sum, so) => 
      sum + so.total_price_cents, 0
    );
        
    const totalServiceQuantity = updatedServiceOptions.reduce((sum, so) => 
      sum + so.quantity, 0
    );

    return {
      ...service,
      service_options: updatedServiceOptions,
      price_cents: totalServicePriceCents,
      combined_price_cents: totalServicePriceCents,
      package_count: totalServiceQuantity,
      adjusted_price_cents: 0,
      combined_adjusted_price_cents: 0
    };
  });
}